export const getNextAriaLabel = el => el.querySelector('.swiper-button-next').getAttribute('data-aria-next');
export const getPrevAriaLabel = el => el.querySelector('.swiper-button-prev').getAttribute('data-aria-prev');
export const getFirstSlideAriaLabel = el => el.querySelector('.swiper__controls').getAttribute('data-aria-first-slide');
export const getLastSlideAriaLabel = el => el.querySelector('.swiper__controls').getAttribute('data-aria-last-slide');

export const getDefaultSliderSettings = el => {
  return {
    speed: 500,
    watchOverflow: true,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    a11y: {
      prevSlideMessage: getPrevAriaLabel(el),
      nextSlideMessage: getNextAriaLabel(el),
      firstSlideMessage: getFirstSlideAriaLabel(el),
      lastSlideMessage: getLastSlideAriaLabel(el)
    }
  };
};
